import { UpdateFinanceTradesApi } from "@/features/accounts/finance/services/update-trades-api";
import { PostFinanceTradesRequestModel } from "@/features/accounts/finance/services/update-trades-model";

/// 銀行明細更新処理
export class UpdateFinanceTradesService {
  private updateFinanceTradesApi = new UpdateFinanceTradesApi();

  /**
   * 銀行明細更新API実行
   */
  public async updateFinanceTrades(param: PostFinanceTradesRequestModel) {
    return await this.updateFinanceTradesApi.updateFinanceTrades(param);
  }
}
